

































































import {Component, Prop, Watch} from 'vue-property-decorator';
import {pickBy, isEqual} from 'lodash';
import {Mixins} from 'vue-property-decorator';
import {Sync} from 'vuex-pathify';
import {GOOGLE_GEOCODE_KEY, GOOGLE_MAPS_KEY, multiNil, nil} from '@/common';
import axios from 'axios';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import {FeathersVuexFindAll} from '@/utils';
import CreateOrEditDialog from '@/components/Views/UI/CreateOrEditDialog.vue';
import GenericDialog from '@/components/Views/UI/GenericDialog.vue';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';

@Component({
    components: {GenericDialog, CreateOrEditDialog},
})
export default class VendorDialog extends Mixins(UserRoleMixin, GlobalAlertMixin) {

    public get minTravelRadius() {
        return this.editedItem.desiredTravelRadius.toFixed(0) + ' miles';
    }

    public get maxTravelRadius() {
        return this.editedItem.maximumTravelRadius.toFixed(0) + ' miles';
    }

    public get creatableUser(): any {
        return {
            email: this.editedItem.email,
            password: this.editedItem.password,
        };
    }

    @Sync('auth/user') public user!: any;

    @Prop({default: () => null})
    public vendor!: any;
    public showingLocation = false;
    public activeMap = '';
    public coordinates: { lat: number, lng: number } | null = null;
    public formattedAddress = '';
    public makeItem = () => ({
        firstName: '',
        disabled: false,
        lastName: '',
        email: '',
        password: '',
        tier: '',
        serviceTypes: [],
        sortPriority: 25,
        desiredTravelRadius: 25,
        maximumTravelRadius: 50,
        location: {
            type: 'Point',
            coordinates: [],
        },
        address: {
            country: '',
            state: '',
            city: '',
            zip: '',
            street: '',
            street2: '',
        },
    });
    public editedItem = this.makeItem();
    public defaultItem = this.makeItem();
    public vendorHasUser = false;
    public tiers: any[] = [];
    public serviceTypes: any[] = [];

    @Watch('vendor')
    public onVendorChanged(value: any, oldValue: any) {
        this.refreshVendor();
    }

    @Watch('editedItem.maximumTravelRadius')
    public onMaximumTravelRadiusChanged(value: number, oldValue: number) {
        if (value < this.editedItem.desiredTravelRadius) {
            this.editedItem.desiredTravelRadius = value;
        }
    }

    @Watch('editedItem.desiredTravelRadius')
    public onDesiredTravelRadiusChanged(value: number, oldValue: number) {
        if (value > this.editedItem.maximumTravelRadius) {
            this.editedItem.maximumTravelRadius = value;
        }
    }

    public onClose() {
        setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.refreshVendor();
        }, 300);
    }
    public async onSubmit(){
        await this.checkAddress();
        let object = Object.assign({}, this.editedItem, {location:this.coordinatesAsGeoJson});
        try {
            if(nil(this.vendor)){
                this.createVendor(object);
            } else {
                this.updateVendor(object);
            }
        } catch (e) {
            console.log(e.message);
            this.showAlert(`Error Trying To ${this.formAction} Pro: ${e.message}`, 'error', 9000);
        }
    }
    public async createVendor(object){
        const {Vendor} = this.$FeathersVuex;
        const v = new Vendor(object);
        await v.save();
        this.close();
    }
    public async updateVendor(object){
        const {Vendor} = this.$FeathersVuex;
        let v = await Vendor.get(this.vendor._id);
        let updates = Object.assign({}, this.editedItem);
        if(!this.didLocationChange(this.vendor, v)){
            delete updates.address;
            delete updates.location;
            await this.forceUpdateVendor(updates, v);
        } else {
            this.showingLocation = true;
        }
    }
    public async toggleDisabled(disabilityStatus){
        const {Vendor} = this.$FeathersVuex;
        const action = disabilityStatus ? 'disabled' : 'enabled';
        let v = await Vendor.get(this.vendor._id);
        v.disabled = disabilityStatus;
        try {
            await v.save();
            this.close();
            this.showAlert(`Succesfully ${action} this pro`, 'success');
        } catch(e){
            this.showAlert(`Error encountered ${action} this pro`);
            console.log(e);
        }
    }
    public async forceUpdateVendor(object, vendor){
        if(nil(vendor)) {
            const {Vendor} = this.$FeathersVuex;
            vendor = await Vendor.get(this.vendor._id);
            delete vendor.location._id;
        }
        Object.assign(vendor, object);
        await vendor.save();
        this.close();
    }
    public mounted() {
        this.initialize();
        this.refreshVendor();
    }

    public async initialize() {
        this.tiers = await FeathersVuexFindAll(this.$FeathersVuex.Tier, {});
        this.serviceTypes = await FeathersVuexFindAll(this.$FeathersVuex.ServiceType, {});
    }

    public get queryableAddress() {
        const {address} = this.editedItem;
        return encodeURI(`${address.street} ${address.street2}, ${address.city} ${address.state} ${address.zip} ${address.country}`);
    }

    public get asGoogleStaticMap() {
        if (nil(this.coordinates, true) || nil(this.coordinates.lng, true) || nil(this.coordinates.lat, true)) {
            return '';
        }
        let center = '';
        if (!nil(this.formattedAddress, true)) {
            center = `&center=${encodeURI(this.formattedAddress)}`;
        }
        const markers = encodeURI(`markers=size:mid|color:red|${this.coordinates.lat},${this.coordinates.lng}`);
        return `https://maps.googleapis.com/maps/api/staticmap?size=1000x300&key=${GOOGLE_MAPS_KEY}${center}&maptype=roadmap&${markers}`;
    }

    public async checkAddress() {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${this.queryableAddress}&key=${GOOGLE_GEOCODE_KEY}`;
        const result = await axios.get(url);
        if (nil(result.data.results) || result.data.results.length === 0) {
            this.showAlert('Error checking address', 'error');
            this.coordinates = null;
            this.formattedAddress = '';
        } else {
            const [location] = result.data.results;
            this.coordinates = location.geometry.location;
            this.formattedAddress = location.formatted_address;
        }
    }

    public async closeAddressDialog(confirm: boolean) {
        this.showingLocation = false;
        this.formattedAddress = '';
        if (!confirm) {
            this.coordinates = null;
            return;
        }
        this.editedItem.location = {
            type: 'Point',
            coordinates: [this.coordinates.lng, this.coordinates.lat],
        };
        this.coordinates = null;
        try{
            await this.forceUpdateVendor(this.editedItem, null);
            this.close();
        } catch (e) {
            console.log(e.message);
            this.showAlert(`Error Trying To ${this.formAction} Pro: ${e.message}`, 'error', 9000);
        }
    }
    public get coordinatesAsGeoJson(): any{
        return {
            type:"Point",
            coordinates: [this.coordinates.lng, this.coordinates.lat],
        }
    }
    public async save() {
        const {Vendor, User} = this.$FeathersVuex;

    }
    public didLocationChange(oldItem, newItem){
        if(!isEqual(oldItem.location.coordinates, newItem.location.coordinates)) return true;
        if(!isEqual(oldItem.address, newItem.address)) return true;
        return false;
    }
    public refreshVendor() {
        this.editedItem = Object.assign({}, this.defaultItem);
        if (nil(this.vendor)) {
            this.activeMap = '';
            this.vendorHasUser = false;
            return;
        } else if (!nil(this.user)) {
            this.vendorHasUser = true;
        }
        this.editedItem = Object.assign({}, this.vendor);

        if (!nil(this.vendor.location, true) && !nil(this.vendor.location.coordinates, true)) {
            this.coordinates = {
                lat: this.vendor.location.coordinates[1],
                lng: this.vendor.location.coordinates[0],
            };
            this.activeMap = this.asGoogleStaticMap;
        }
        (this.$refs.tierSelect as any).selectItem(this.editedItem.tier);
        // (this.$refs.categorySelect as any).selectItem(this.editedItem.category);
        if (nil(this.editedItem.address)) {
            this.editedItem.address = Object.assign({}, this.defaultItem.address);
        }
    }

    public open() {
        (this.$refs.dialog as any).open = true;
    }

    public close() {
        (this.$refs.dialog as any).open = false;
    }
}
